export default __webpack_public_path__ + "static/media/dev.3f2739b3.png";